<a (click)="addRecord()">{{linkText}}</a>